// import React, { useEffect, useState } from "react";
// import Plot from "react-plotly.js";
// import useHttp from "../../../hook/use-http";
// import { API_URL_MAIN } from "../../../constants/driveglobalfilterinitalstates_bus";

// const Test = ({ filterdata }) => {
//     const { isLoading, error, sendReq: fetchData } = useHttp();
//     const [packTypeCurrent, setPackTypeCurrent] = useState('A');
//     const [packTypeTemperature, setPackTypeTemperature] = useState('A');
//     const [packData, setPackData] = useState(null);
//     const [temperatureData, setTemperatureData] = useState(null);
//     const [sensorType, setSensorType] = useState("sensor1");

//     const handlePackChangeCurrent = (e) => {
//         setPackTypeCurrent(e.target.value);
//     };

//     const handlePackChangeTemperature = (e) => {
//         setPackTypeTemperature(e.target.value);
//     };

//     const handleSensorChange = (e) => {
//         setSensorType(e.target.value);
//     };

//     useEffect(() => {
//         if (packTypeCurrent) {
//             fetchData(
//                 {
//                     url: `${API_URL_MAIN}battery_digital_twin/Histogram_current`,
//                     body: { packType: packTypeCurrent, filterdata },
//                 },
//                 (data) => {
//                     if (data && Array.isArray(data)) {
//                         const xValues = data
//                             .map((item) => item.Pack_Curr_hist)
//                             .filter((val) => typeof val === "number" && !isNaN(val));
//                         setPackData(xValues);
//                     }
//                 }
//             );
//         }
//     }, [packTypeCurrent, filterdata]);

//     useEffect(() => {
//         if (packTypeTemperature && sensorType) {
//             fetchData(
//                 {
//                     url: `${API_URL_MAIN}battery_digital_twin/Histogram_temperature`,
//                     body: { packType: packTypeTemperature, filterdata },
//                 },
//                 (data) => {
//                     const normalizeSensorName = (sensor) => {
//                         if (sensor.startsWith("sensor")) {
//                             return `Sensor${sensor.replace("sensor", "")}`;
//                         }
//                         if (sensor === "coolant_in") return "Coolant_In";
//                         if (sensor === "coolant_out") return "Coolant_Out";
//                         return sensor;
//                     };

//                     const normalizedSensorType = normalizeSensorName(sensorType);

//                     if (!Object.keys(data[0]).includes(normalizedSensorType)) {
//                         console.error(`Sensor type "${normalizedSensorType}" not found in API response.`);
//                         return;
//                     }

//                     let xValues = data.map((item) => item[normalizedSensorType] ?? null);
//                     xValues = xValues.filter((value) => value !== null && value !== 0);
//                     xValues = xValues.map(value => value / 1000);
//                     setTemperatureData(xValues);
//                     console.log(normalizedSensorType, xValues);
//                 }
//             );
//         }
//     }, [packTypeTemperature, sensorType, filterdata]);

//     return (
//         <div className="container mt-4">
//             <div className="row">
//                 {/* Current Profile */}
//                 <div className="col-md-6">
//                     <h3 className="text-center mb-3">Pack Current Profile</h3>
//                     <div className="mb-3 d-flex align-items-center justify-content-center">
                        
//                         <div className="flex space-x-5">
//                             {["A", "B", "C", "D"].map((pack) => (
//                                 <label key={pack} className="inline-flex items-center">
//                                     <input
//                                         type="radio"
//                                         name="packTypeCurrent"
//                                         value={pack}
//                                         checked={packTypeCurrent === pack}
//                                         onChange={handlePackChangeCurrent}
//                                         className="form-radio h-4 w-4 text-blue-600 mr-1"
//                                     />
//                                     <span>Pack {pack}</span>
//                                 </label>
//                             ))}
//                         </div>
//                     </div>

//                     <div className="d-flex justify-content-center">
//                         {packData && packData.length > 0 ? (
//                             <Plot
//                                 data={[
//                                     {
//                                         x: packData,
//                                         type: "histogram",
//                                         histnorm: "probability density",
//                                         marker: { color: "rgba(0,0,255,0.5)" },
//                                         xbins: {
//                                             start: Math.min(...packData) - 10,
//                                             end: Math.max(...packData) + 10,
//                                         },
//                                     },
//                                 ]}
//                                 layout={{
                                    
//                                     xaxis: {
//                                         title: "Pack Current (A)",
//                                         zeroline: false,
//                                         showgrid: false,
//                                     },
//                                     yaxis: {
//                                         title: "Normalized Distribution",
//                                         showgrid: false,
//                                     },
//                                     bargap: 0.05,
//                                     showlegend: false,
//                                     width: 450,
//                                     height: 400,
//                                 }}
//                                 config={{ displayModeBar: false }}
//                             />
//                         ) : (
//                             <p>No Data Available</p>
//                         )}
//                     </div>
//                 </div>

//                 {/* Temperature Profile */}
//                 <div className="col-md-6">
//                     <h3 className="text-center mb-3">Temperature Profile</h3>
//                     <div className="mb-3 d-flex align-items-center justify-content-center space-x-5">
//                         <div className="d-flex align-items-center">
                            
//                             <div className="flex space-x-4">
//                                 {["A", "B", "C", "D"].map((pack) => (
//                                     <label key={pack} className="inline-flex items-center">
//                                         <input
//                                             type="radio"
//                                             name="packTypeTemperature"
//                                             value={pack}
//                                             checked={packTypeTemperature === pack}
//                                             onChange={handlePackChangeTemperature}
//                                             className="form-radio h-4 w-4 text-blue-600 mr-1"
//                                         />
//                                         <span>Pack {pack}</span>
//                                     </label>
//                                 ))}
//                             </div>
//                         </div>
//                         <div className="d-flex align-items-center">
//                             <label className="me-2">Select Sensor:</label>
//                             <select
//                                 value={sensorType}
//                                 onChange={handleSensorChange}
//                                 className="form-select"
//                                 style={{ width: "140px" }}
//                             >
//                                 {[...Array(12).keys()].map((i) => (
//                                     <option key={i} value={`sensor${i + 1}`}>
//                                         {`Sensor ${i + 1}`}
//                                     </option>
//                                 ))}
//                                 <option value="coolant_in">Coolant In</option>
//                                 <option value="coolant_out">Coolant Out</option>
//                             </select>
//                         </div>
//                     </div>

//                     <div className="d-flex justify-content-center">
//                         {temperatureData && (
//                             <Plot
//                                 data={[
//                                     {
//                                         x: temperatureData,
//                                         type: "histogram",
//                                         marker: { color: "rgba(0,0,255,0.5)" },
//                                     },
//                                 ]}
//                                 layout={{
                                
//                                     xaxis: {
//                                         title: "Temperature (°C)",
//                                         range: [
//                                             Math.min(...temperatureData) - 10,
//                                             Math.max(...temperatureData) + 10,
//                                         ],
//                                     },
//                                     yaxis: { title: "Normalized Distribution" },
//                                     bargap: 0.8,
//                                     width: 450,
//                                     height: 400,
//                                 }}
//                                 config={{ displayModeBar: false }}
//                             />
//                         )}
//                     </div>
//                 </div>
//             </div>
//         </div>
//     );
// };

// export default Test;

import React, { useEffect, useState } from "react";
import Plot from "react-plotly.js";
import useHttp from "../../../hook/use-http";
import { API_URL_MAIN } from "../../../constants/driveglobalfilterinitalstates_bus";

const Test = ({ filterdata }) => {
    const { isLoading, error, sendReq: fetchData } = useHttp();
    const [packTypeCurrent, setPackTypeCurrent] = useState('A');
    const [packTypeTemperature, setPackTypeTemperature] = useState('A');
    const [packData, setPackData] = useState(null);
    const [temperatureData, setTemperatureData] = useState(null);
    const [sensorType, setSensorType] = useState("sensor1");

    const handlePackChangeCurrent = (e) => {
        setPackTypeCurrent(e.target.value);
    };

    const handlePackChangeTemperature = (e) => {
        setPackTypeTemperature(e.target.value);
    };

    const handleSensorChange = (e) => {
        setSensorType(e.target.value);
    };

    useEffect(() => {
        if (packTypeCurrent) {
            fetchData(
                {
                    url: `${API_URL_MAIN}battery_digital_twin/Histogram_current`,
                    body: { packType: packTypeCurrent, filterdata },
                },
                (data) => {
                    if (data && Array.isArray(data)) {
                        const xValues = data
                            .map((item) => item.Pack_Curr_hist)
                            .filter((val) => typeof val === "number" && !isNaN(val));
                        setPackData(xValues);
                    }
                }
            );
        }
    }, [packTypeCurrent, filterdata]);

    useEffect(() => {
        if (packTypeTemperature && sensorType) {
            fetchData(
                {
                    url: `${API_URL_MAIN}battery_digital_twin/Histogram_temperature`,
                    body: { packType: packTypeTemperature, filterdata },
                },
                (data) => {
                    const normalizeSensorName = (sensor) => {
                        if (sensor.startsWith("sensor")) {
                            return `Sensor${sensor.replace("sensor", "")}`;
                        }
                        if (sensor === "coolant_in") return "Coolant_In";
                        if (sensor === "coolant_out") return "Coolant_Out";
                        return sensor;
                    };

                    const normalizedSensorType = normalizeSensorName(sensorType);

                    if (!Object.keys(data[0]).includes(normalizedSensorType)) {
                        console.error(`Sensor type "${normalizedSensorType}" not found in API response.`);
                        return;
                    }

                    let xValues = data.map((item) => item[normalizedSensorType] ?? null);
                    xValues = xValues.filter((value) => value !== null && value !== 0);
                    xValues = xValues.map(value => value / 1000);
                    setTemperatureData(xValues);
                    console.log(normalizedSensorType, xValues);
                }
            );
        }
    }, [packTypeTemperature, sensorType, filterdata]);

    return (
        <div className="container mt-4">
            <div className="row align-items-start">
                {/* Current Profile */}
                <div className="col-md-6">
                    <h3 className="text-center mb-3">Pack Current Profile</h3>
                    <div className="mb-3 d-flex align-items-center justify-content-center" style={{ height: '70px' }}>
                        <div className="flex space-x-5">
                            {["A", "B", "C", "D"].map((pack) => (
                                <label key={pack} className="inline-flex items-center">
                                    <input
                                        type="radio"
                                        name="packTypeCurrent"
                                        value={pack}
                                        checked={packTypeCurrent === pack}
                                        onChange={handlePackChangeCurrent}
                                        className="form-radio h-4 w-4 text-blue-600 mr-1"
                                    />
                                    <span>Pack {pack}</span>
                                </label>
                            ))}
                        </div>
                    </div>

                    <div className="d-flex justify-content-center">
                        {packData && packData.length > 0 ? (
                            <Plot
                                data={[
                                    {
                                        x: packData,
                                        type: "histogram",
                                        histnorm: "probability density",
                                        marker: { color: "rgba(0,0,255,0.5)" },
                                        xbins: {
                                            start: Math.min(...packData) - 10,
                                            end: Math.max(...packData) + 10,
                                        },
                                    },
                                ]}
                                layout={{
                                    xaxis: {
                                        title: "Pack Current (A)",
                                        zeroline: false,
                                        showgrid: false,
                                    },
                                    yaxis: {
                                        title: "Normalized Distribution",
                                        showgrid: false,
                                    },
                                    bargap: 0.05,
                                    showlegend: false,
                                    width: 450,
                                    height: 400,
                                }}
                                config={{ displayModeBar: false }}
                            />
                        ) : (
                            <p>No Data Available</p>
                        )}
                    </div>
                </div>

                {/* Temperature Profile */}
                <div className="col-md-6">
                    <h3 className="text-center mb-3">Temperature Profile</h3>
                    <div className="mb-3 d-flex align-items-center justify-content-center space-x-5" style={{ height: '70px' }}>
                        <div className="d-flex align-items-center">
                            <div className="flex space-x-4">
                                {["A", "B", "C", "D"].map((pack) => (
                                    <label key={pack} className="inline-flex items-center">
                                        <input
                                            type="radio"
                                            name="packTypeTemperature"
                                            value={pack}
                                            checked={packTypeTemperature === pack}
                                            onChange={handlePackChangeTemperature}
                                            className="form-radio h-4 w-4 text-blue-600 mr-1"
                                        />
                                        <span>Pack {pack}</span>
                                    </label>
                                ))}
                            </div>
                        </div>
                        <div className="d-flex align-items-center">
                            <label className="me-2">Select Sensor:</label>
                            <select
                                value={sensorType}
                                onChange={handleSensorChange}
                                className="form-select"
                                style={{ width: "140px" }}
                            >
                                {[...Array(12).keys()].map((i) => (
                                    <option key={i} value={`sensor${i + 1}`}>
                                        {`Sensor ${i + 1}`}
                                    </option>
                                ))}
                                <option value="coolant_in">Coolant In</option>
                                <option value="coolant_out">Coolant Out</option>
                            </select>
                        </div>
                    </div>

                    <div className="d-flex justify-content-center">
                        {temperatureData && (
                            <Plot
                                data={[
                                    {
                                        x: temperatureData,
                                        type: "histogram",
                                        marker: { color: "rgba(0,0,255,0.5)" },
                                    },
                                ]}
                                layout={{
                                    xaxis: {
                                        title: "Temperature (°C)",
                                        range: [
                                            Math.min(...temperatureData) - 10,
                                            Math.max(...temperatureData) + 10,
                                        ],
                                    },
                                    yaxis: { title: "Normalized Distribution" },
                                    bargap: 0.8,
                                    width: 450,
                                    height: 400,
                                }}
                                config={{ displayModeBar: false }}
                            />
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Test;
